<onyx-section [heading]="`${I18N}.heading`">
  <div class="container">
    @if (chips().length > 1) {
      <onyx-chips
        label="labels.settings"
        [chips]="chips()"
        variant="secondary"
        [single]="true"
        [gap]="8"
        [(activeValues)]="selectedBranch"
      ></onyx-chips>
    }

    <div class="item">
      @if (selectedBranchForm() !== mainBranchForm()) {
        @let disabled = !selectedBranchForm() && mainBranchForm().invalid;
        <onyx-toggle
          label="labels.customSettings"
          [checked]="!!selectedBranchForm()"
          [disabled]="disabled"
          [onyxTooltip]="
            disabled ? 'labels.setDefaultSettingsFirst' : undefined
          "
          (checkedChange)="$event ? addBranchForm() : removeBranchForm()"
        ></onyx-toggle>
      }

      @if (selectedBranchForm(); as selectedBranchForm) {
        @for (branchForm of form().controls; track branchForm) {
          @if (branchForm === selectedBranchForm) {
            <app-contractor-invoice-form
              [form]="branchForm"
              [country]="country()"
            ></app-contractor-invoice-form>
          }
        }
      }
    </div>
  </div>
</onyx-section>
